module.exports = __webpack_public_path__ + "static/header-image-4c3906741fd9389b334e65ff4fcf4335.png";